module.exports = __webpack_public_path__ + "img/9788959760763.3b4ee81f.jpg";